"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLinkPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DefaultLinkPreview_module_css_1 = __importDefault(require("./DefaultLinkPreview.module.css"));
const GhostOutline_svg_1 = __importDefault(require("./GhostOutline.svg"));
/**
 * A default preview, yellow background with the Snapchat ghost logo.
 * Can be used for pages without a dedicated preview or as a placeholder
 * while a specific preview is being created
 */
function DefaultLinkPreview() {
    return ((0, jsx_runtime_1.jsx)("div", { className: DefaultLinkPreview_module_css_1.default.container, children: (0, jsx_runtime_1.jsx)(GhostOutline_svg_1.default, {}) }));
}
exports.DefaultLinkPreview = DefaultLinkPreview;
//# sourceMappingURL=DefaultLinkPreview.js.map